import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "@/hooks/trpc";
import { useMemo } from "react";
import { ProtocolCleaningRequirements } from "@/features/harvest-protocol/editor/protocol-cleaning-requirements";
import type { EquipmentId, EquipmentTypeId } from "@brewbase/db/types";

export const Route = createFileRoute(
  "/harvests/protocols/$protocol_id/cleaning",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { protocol_id } = Route.useParams();
  const { data: protocol } =
    trpc.harvest.protocols.getWithFullDetails.useQuery(protocol_id);

  const protocolEquipment = useMemo(() => {
    if (!protocol?.operations) return [];
    // Collect distinct equipment from operations that have equipment assigned
    const seen = new Set<number>();
    return protocol.operations
      .filter((op) => op.equipment_id != null && op.equipment != null)
      .reduce(
        (acc, op) => {
          const eqId = op.equipment_id!;
          if (seen.has(eqId as number)) return acc;
          seen.add(eqId as number);
          acc.push({
            equipmentId: eqId,
            equipmentName: op.equipment?.name ?? "Unknown",
            equipmentTypeId:
              op.operation_template?.equipment_type_id ?? null,
            equipmentTypeName:
              op.operation_template?.equipment_type_name ?? null,
          });
          return acc;
        },
        [] as Array<{
          equipmentId: EquipmentId;
          equipmentName: string;
          equipmentTypeId: EquipmentTypeId | null;
          equipmentTypeName: string | null;
        }>,
      )
      .sort((a, b) => a.equipmentName.localeCompare(b.equipmentName));
  }, [protocol?.operations]);

  if (!protocol) return null;

  return (
    <div className="p-6 max-w-3xl">
      <ProtocolCleaningRequirements
        protocolId={protocol_id}
        equipment={protocolEquipment}
      />
    </div>
  );
}
